module.exports = {
      id: "close-bold-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#close-bold",
      toString: function () {
        return this.url;
      }
    }